import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, MessageCircle, PlusSquare, User, Wand2, Search } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import LanguagePopup from './LanguagePopup';
import SidebarSearch from './SidebarSearch';

const DesktopSidebar: React.FC = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const { isAuthenticated } = useAuth();
  const [isLanguagePopupOpen, setIsLanguagePopupOpen] = useState(false);
  
  const isActive = (path: string): boolean => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <div className="fixed inset-y-0 left-0 w-64 bg-white shadow-xl flex flex-col h-full border-r border-gray-200 hidden md:flex">
        {/* Logo */}
        <div className="p-5 border-b">
          <Link to="/" className="text-xl font-bold">
            WANTTD
          </Link>
        </div>
        
        {/* Search box */}
        <div className="p-5">
          {/* <SidebarSearch /> */}
        </div>
        
        {/* Navigation links */}
        <nav className="flex-1 px-5 space-y-1">
          <Link 
            to="/" 
            className={`flex items-center space-x-2 p-2 rounded-md text-sm ${isActive('/') ? 'font-medium' : 'text-gray-700'}`}
          >
            <Home className="h-5 w-5" />
            <span>Home</span>
          </Link>
          
          {/* <Link 
            to="/explore" 
            className={`flex items-center space-x-2 p-2 rounded-md text-sm ${isActive('/explore') ? 'font-medium' : 'text-gray-700'}`}
          >
            <Compass className="h-5 w-5" />
            <span>Explore</span>
          </Link> */}
          
          <Link 
            to="/search" 
            className={`flex items-center space-x-2 p-2 rounded-md text-sm ${isActive('/search') ? 'font-medium' : 'text-gray-700'}`}
          >
            <Search className="h-5 w-5" />
            <span>Search</span>
          </Link>
          
          <Link 
            to="/chat" 
            className={`flex items-center space-x-2 p-2 rounded-md text-sm ${isActive('/chat') ? 'font-medium' : 'text-gray-700'}`}
          >
            <MessageCircle className="h-5 w-5" />
            <span>Message</span>
          </Link>
          
          <Link 
            to="/create-will" 
            className={`flex items-center space-x-2 p-2 rounded-md text-sm ${isActive('/create-will') ? 'font-medium' : 'text-gray-700'}`}
          >
            <PlusSquare className="h-5 w-5" />
            <span>Want</span>
          </Link>
          
          <Link 
            to="/my-genies" 
            className={`flex items-center space-x-2 p-2 rounded-md text-sm ${isActive('/my-genies') ? 'font-medium' : 'text-gray-700'}`}
          >
            <Wand2 className="h-5 w-5" />
            <span>My Genies</span>
          </Link>
          
          <Link 
            to="/profile" 
            className={`flex items-center space-x-2 p-2 rounded-md text-sm ${isActive('/profile') ? 'font-medium' : 'text-gray-700'}`}
          >
            <User className="h-5 w-5" />
            <span>Profile</span>
          </Link>
        </nav>
        
        {/* Login button */}
        {!isAuthenticated && (
          <div className="p-5">
            <Link to="/signin">
              <button className="w-full py-2 bg-yellow-400 text-white rounded-md text-sm font-medium">
                Log in
              </button>
            </Link>
          </div>
        )}
        
        {/* Footer links */}
        <div className="p-5 text-xs text-gray-500 space-x-2 border-t">
          <a href="https://about.wanttd.com/" target="_blank" rel="noopener noreferrer" className="hover:underline">
            About
          </a>
          <span>·</span>
          <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="hover:underline">
            Privacy
          </Link>
          <span>·</span>
          <Link to="/terms" target="_blank" rel="noopener noreferrer" className="hover:underline">
            Terms
          </Link>
          <span>·</span>
          <button 
            onClick={() => setIsLanguagePopupOpen(true)}
            className="hover:underline"
          >
            Language
          </button>
        </div>
        
        {/* Copyright */}
        <div className="px-5 pb-5 text-xs text-gray-400">
          © 2025 WANTTD
        </div>
      </div>
      
      {/* Language popup */}
      <LanguagePopup 
        isOpen={isLanguagePopupOpen} 
        onClose={() => setIsLanguagePopupOpen(false)} 
      />
    </>
  );
};

export default DesktopSidebar; 